import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgbDropdownModule, NgbModalModule, NgbPopoverModule, NgbProgressbarModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { UiIconModule } from './icon/icon.module';
import { UiFieldComponent } from './field/field.component';
import { UiFieldPasswordComponent } from './field/field-password.component';
import { FieldTrimDirective } from './field/field-trim.directive';
import { FieldRegexpDirective } from './field/field-regexp.directive';
import { FieldCapitalizeFirstDirective } from './field/field-capitalize-first';
import { UiMessageComponent } from './message/message.component';
import { UiLoaderComponent } from './loader/loader.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { CheckboxSliderComponent } from './checkbox/checkbox-slider.component';
import { SelectComponent } from './select/select.component';
import { ComboboxComponent } from './combobox/combobox.component';
import { ComboboxSearchPipe, ComboboxSearchHighlightPipe } from './combobox/combobox.pipes';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { DateTimePickerModule } from './date-time-picker/date-time-picker.module';
import { TypeaheadComponent } from './typeahead/typeahead.component';
import { UiRadioButtonComponent } from './radio-button/radio-button.component';

import { UIDatePickerModule } from './date-picker/date-picker.module';
import { UITimePickerModule } from './time-picker/time-picker.module';
import { TabsComponent } from './tabs/tabs.component';
import { TabComponent } from './tabs/tab.component';
import { SelectMultipleComponent } from './select-multiple/select-multiple.component';
import { PipesModule } from '../shared/pipes/pipes.module';
import { SwitchComponent } from './switch/switch.component';

@NgModule({
    declarations: [
        UiFieldComponent,
        UiFieldPasswordComponent,
        FieldTrimDirective,
        FieldRegexpDirective,
        FieldCapitalizeFirstDirective,
        UiMessageComponent,
        UiLoaderComponent,
        CheckboxComponent,
        CheckboxSliderComponent,
        SelectComponent,
        ComboboxComponent,
        ComboboxSearchPipe,
        ComboboxSearchHighlightPipe,
        DateTimePickerComponent,
        TypeaheadComponent,
        UiRadioButtonComponent,
        TabsComponent,
        TabComponent,
        SelectMultipleComponent,
        SwitchComponent,
    ],
    imports: [
        NgbDropdownModule,
        NgbModalModule,
        NgbPopoverModule,
        NgbProgressbarModule,
        NgbTypeaheadModule,
        FormsModule,
        CommonModule,
        DateTimePickerModule,
        UIDatePickerModule,
        UITimePickerModule,
        UiIconModule,
        PipesModule,
        ReactiveFormsModule,
    ],
    exports: [
        NgbDropdownModule,
        NgbModalModule,
        NgbPopoverModule,
        NgbProgressbarModule,
        NgbTypeaheadModule,
        UiIconModule,
        UiFieldComponent,
        UiFieldPasswordComponent,
        FieldTrimDirective,
        FieldRegexpDirective,
        FieldCapitalizeFirstDirective,
        UiMessageComponent,
        UiLoaderComponent,
        CheckboxComponent,
        CheckboxSliderComponent,
        SelectComponent,
        ComboboxComponent,
        DateTimePickerModule,
        DateTimePickerComponent,
        UIDatePickerModule,
        UITimePickerModule,
        TypeaheadComponent,
        UiRadioButtonComponent,
        TabsComponent,
        TabComponent,
        SelectMultipleComponent,
        SwitchComponent,
    ],
    providers: [],
    bootstrap: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppUiModule {}
